import { render, staticRenderFns } from "./cpTag.vue?vue&type=template&id=4b98c6de"
import script from "./cpTag.vue?vue&type=script&lang=js"
export * from "./cpTag.vue?vue&type=script&lang=js"
import style0 from "./cpTag.vue?vue&type=style&index=0&id=4b98c6de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports